import GenresRoute from '../../beatport/content/GenresRoute';
export default GenresRoute;
